import gql from 'graphql-tag';

export const queryMultiLingualByModuleIndex = gql`
	query QueryMultiLingualByModuleIndex(
		$module: String!
		$first: Int
		$after: String
	) {
		queryMultiLingualByModuleIndex(
			module: $module
			first: $first
			after: $after
		) {
			items {
				id
				key
				languageCode
				matchKey
				module
				text
			}
			nextToken
		}
	}
`;
